/**
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 *
 * THIS FILE IS MANAGED CENTRALLY BY THE `common-code` REPO.
 * IT COULD BE AUTO-REPLACED AT ANY TIME.
 * DO NOT MAKE CUSTOM CHANGES TO THIS FILE.
 * @see https://gitlab.com/dea-aero/development/common-code
 *
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 */
import {useState, useEffect, useCallback, useMemo} from "react";
import {Button} from "@mui/material";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import {useNavigate} from "react-router-dom";
import Container from "@mui/material/Container";

import {useApiCallback} from "../util/Api";
import GenericSelect from "../part/GenericSelect";
import {useLoginStore} from "../useLoginStore";
import {cellDefaults, DataGrid} from "../part/DataGrid";


export default function AclRoles() {
    const canUser = useLoginStore(state => state.canUser);
    const permissions = useLoginStore(state => state.permissions);

    const [loading, setLoading] = useState(false)
    const [acls, setAcls] = useState([])
    const [group, setGroup] = useState('')
    const [authority, setAuthority] = useState('')
    const [role, setRole] = useState('')
    const [disableDel, setDisableDel] = useState(true)
    const [disableAdd, setDisableAdd] = useState(true)
    const [groups, setGroups] = useState([])
    const [aclSelection, setAclSelection] = useState([])
    const [focus, setFocus] = useState('')
    const [roles, setRoles] = useState([])

    const gotAcls = useCallback(dd => setAcls(dd.map(d => ({
        id: d.email + ' ' + d.authority + ' ' + d.role,
        ...d
    }))), [setAcls])

    const fetchGroups = useApiCallback('GET', '/api/groups', {setLoading, onDone: setGroups})
    useEffect(fetchGroups, [fetchGroups, permissions])

    const fetchRoles = useApiCallback('GET', '/api/roles', {setLoading, onDone: setRoles})
    useEffect(fetchRoles, [fetchRoles, permissions])

    const fetchAssignedRoles = useApiCallback('GET', '/api/assignedroles', {setLoading, onDone: gotAcls})
    useEffect(fetchAssignedRoles, [fetchAssignedRoles, permissions])

    const addAssignment = useApiCallback('POST', '/api/assignedrole', {
        data: {role, group, authority},
        setLoading,
        onDone: fetchAssignedRoles
    })
    const removeAssignment = useApiCallback('DELETE', '/api/assignedrole', {
        data: {role, group, authority},
        setLoading,
        onDone: fetchAssignedRoles
    })

    const exists = useMemo(() => {
        return acls.find(acl => acl.id === group + ' ' + authority + ' ' + role)
    }, [acls, group, authority, role])

    useEffect(() => {
        if (focus !== 'left') {
            return;
        }
        if (!aclSelection.length) {
            return;
        }
        const found = acls.filter(acl => aclSelection.indexOf(acl.id) > -1);
        const roles = found.map(acl => acl.role);
        if (roles.length > 1) {
            setRole(`${roles.length} roles selected`);
            console.log('ASDASD', 'set multi roles from left', roles)
        } else if(found.length) {
            console.log('ASDASD', 'set roles from left', found[0])
            setGroup(found[0].email);
            setAuthority(found[0].authority);
            setRole(found[0].role);
        }
        // dont clear existing selections or it clears boxes when a row is deleted
    }, [aclSelection, focus, acls, setGroup, setAuthority, setRole])

    const canSetAcl = useMemo(() => canUser('POST', `/api/role/${role}`), [role, canUser]);

    useEffect(() => {
        const id = group + ' ' + authority + ' ' + role
        const ids = acls.map(acl => acl.id)
        console.log('authority && group && roles.length', authority, group, roles.length)
        setDisableDel((!roles.length && ids.indexOf(id) === -1) || !authority || !group)
        setDisableAdd(ids.indexOf(id) > -1 || !authority || !group || !roles.length)
    }, [acls, role, group, authority, roles.length, setDisableDel, setDisableAdd])

    return <Container>
        <Stack justifyContent="center" alignItems="start">
            {canSetAcl ? <>
            <Grid container alignItems="center">
                <Grid item xs={8} md={4}>
                    <GenericSelect
                        setValue={setGroup}
                        value={group}
                        label="Group Email"
                        options={groups.map(g => ({label: `${g.name} <${g.email}>`, code: g.email}))}
                        disabled={loading}
                    />
                </Grid>
                <Grid item xs={4} md={2}>
                    <GenericSelect
                        setValue={setAuthority}
                        value={authority}
                        label="Authority"
                        options={['member', 'manager', 'owner']}
                        disabled={loading}
                    />
                </Grid>
                <Grid item xs={8} md={4}>
                    <GenericSelect
                        setValue={setRole}
                        value={role}
                        label="Role"
                        options={roles}
                        disabled={loading}
                        onFocus={() => setFocus('top')}
                    />
                </Grid>
                <Grid item md={1} xs={2} alignItems="center" justifyItems="center">
                {exists
                    ? <Button sx={{width: '100%'}} disabled={loading || disableDel} onClick={() => removeAssignment()}>
                        Delete
                    </Button>
                    : <Button sx={{width: '100%'}} disabled={loading || disableAdd} onClick={() => addAssignment()}>
                        Add
                    </Button>
                }
                </Grid>
            </Grid>
            </> : ''}
                <Grid container>
                    <Grid item xs={12} sx={{height: {md:'calc(100dvh - 145px)', xs:'calc(50vh - 90px)'}}}>
                        <AclGrid
                            wrapperStyle={{height: '100%'}}
                            selected={aclSelection}
                            setSelected={setAclSelection}
                            onFocus={() => setFocus('left')}
                            {...{acls, loading, group, authority, role}}
                        />
                    </Grid>
                </Grid>
        </Stack>
    </Container>
}


const AclGrid = ({acls, wrapperStyle, selected, setSelected, loading, onFocus, group, authority, role}) => {
    const navigate = useNavigate();
    const canUser = useLoginStore(state => state.canUser);

    const styleFlex = useCallback(cell => {
        let val = cell.value
        if ((cell.field === 'group' || cell.field === 'authority') &&
            (group !== cell.row.group || authority !== cell.row.authority)) {
            return 'acl_deselected';
        }
        else if (cell.field === 'role' && role !== val) {
            return 'acl_deselected';
        }
        return 'acl_selected'
    }, [group, authority, role])

    const toolbar = useMemo(() => {
        if (!group) return []
        if (!canUser('GET', `/api/group/members/${group}`)) return []
        return <>
            <Button size="small" onClick={() => navigate(`/group/${group}`)} color="info">Group Info…</Button>
        </>
    }, [canUser, group, navigate])

    return <DataGrid
        wrapperStyle={wrapperStyle}
        loading={loading}
        rows={acls}
        onCellClick={onFocus}
        rowSelectionModel={selected}
        onRowSelectionModelChange={setSelected}
        columns={[
            {field: 'email', headerName: 'Group', flex: 4, ...cellDefaults,
                valueGetter: (cell, row) => `${cell?.row?.name || row?.name} <${row?.email || cell?.row?.email}>`,
                cellClassName: styleFlex
            },
            {field: 'authority', headerName: 'Authority', flex: 1, cellClassName: styleFlex},
            {field: 'role', headerName: 'Role', flex: 4, cellClassName: styleFlex},
            {field: 'rules', headerName: 'Rules', flex: 4}
        ]}
        initialState={{
            sorting: {
                sortModel: [
                    {field:'group', sort:'asc'},
                    {field:'authority', sort:'asc'},
                    {field:'role', sort:'asc'}
                ],
            }
        }}
        toolbar={toolbar}
    />
}
